import { User } from '../types';

export const users: User[] = [
  {
    email: 'rajesh@mactai.com',
    password: 'rajesh123',
    name: 'Rajesh'
  },
  {
    email: 'madhava@mactai.com',
    password: 'madhava123',
    name: 'Madhava'
  }
];